
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

interface ErrorDetailsProps {
  errorDetails: string | null;
  onDismiss: () => void;
}

const ErrorDetails = ({ errorDetails, onDismiss }: ErrorDetailsProps) => {
  if (!errorDetails) return null;
  
  const handleCopyToClipboard = () => {
    try {
      navigator.clipboard.writeText(errorDetails);
      toast.success("Error details copied to clipboard");
    } catch (e) {
      toast.error("Failed to copy: " + e.message);
    }
  };
  
  return (
    <div className="mb-6 p-4 border border-red-200 rounded-md bg-red-50">
      <h3 className="font-medium text-red-800 mb-2">Error Details (for debugging):</h3>
      <pre className="text-xs overflow-auto p-2 bg-white rounded border border-red-100 max-h-60">
        {errorDetails}
      </pre>
      <div className="flex gap-2 mt-2">
        <Button 
          variant="outline" 
          size="sm" 
          onClick={onDismiss}
        >
          Dismiss
        </Button>
        <Button 
          variant="outline" 
          size="sm" 
          onClick={handleCopyToClipboard}
        >
          Copy to Clipboard
        </Button>
      </div>
    </div>
  );
};

export default ErrorDetails;
